export default "__VITE_ASSET__DUBUOvZd__"